import { Container } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getXlData } from "../../actions/xlActions";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { useHistory } from "react-router-dom";
const inputStyle = {
  padding: "0.75rem 0.75rem",
  width: "50%",
  fontSize: "0.8rem",
  lineHeight: 1.25,
  color: "#55595c",
  backgroundColor: "#fff",
  backgroundImage: "none",
  backgroundClip: "padding-box",
  borderTop: "0",
  borderRight: "0",
  borderBottom: "1px solid #eee",
  borderLeft: "0",
  borderRadius: "3px",
  transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
};
const iconStyle = {
  fontSize: "1.5rem",
  marginRight: "8px",
  position: "absolute",
  right: "50%",
  top: 10,
};

const filterStyle = {
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  width: "100%",
  paddingBottom: "50px",
};

const XL = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const dispatch = useDispatch();
  const { xlData } = useSelector((state) => state.xl);
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    dispatch(getXlData());
  }, [dispatch]);

  const filteredData = Object.keys(xlData).map((keyName) => {
    return {
      keyName,
      data: xlData[keyName].filter((e) => {
        // Check if any value contains the search term
        return Object.values(e).some((value, index) => {
          if (typeof value === "string") {
            return (
              value.toLowerCase().includes(searchTerm.toLowerCase()) ||
              value.toLowerCase().includes("skills-code")
            );
          }
          // If the value is not a string, convert it to a string and then check
          return (
            value.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            value.toString().toLowerCase().includes("skills-code")
          );
        });
      }),
    };
  });

  if (user?.result._id !== "64e4dc6bb8998e0acf113584") {
    history.push("/");
  }
  return (
    <Container style={{ width: "85%" }}>
      <div style={filterStyle}>
        <input
          placeholder="Search ... "
          name="search"
          type="text"
          style={inputStyle}
          value={searchTerm}
          autoFocus
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <SearchRoundedIcon style={iconStyle} />
      </div>

      <div>
        {filteredData?.map((item, i) => (
          <div key={i}>
            <h3>{item.keyName}:</h3>
            <TableContainer>
              <Table>
                <TableHead>
                  {item.data.map((e, index) => (
                    <TableRow key={index}>
                      {Object.values(e).map((el, j) => (
                        <TableCell
                          style={{
                            backgroundColor:
                              typeof el === "string" && searchTerm !== ""
                                ? el

                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                  ? "green"
                                  : "white"
                                : "white",
                          }}
                          key={j}
                        >
                          {el}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default XL;
